import { useCallback, useState } from 'react';

/** Wraps a create handler so React useState never receives a bare function (avoids functional-updater trap). */
export type HeaderCreateRegistration = { run: () => void } | null;

export function useHeaderCreateRegistration(): [
  HeaderCreateRegistration,
  (fn: (() => void) | null) => void,
] {
  const [payload, setPayload] = useState<HeaderCreateRegistration>(null);

  const register = useCallback((fn: (() => void) | null) => {
    setPayload(fn ? { run: fn } : null);
  }, []);

  return [payload, register];
}
